import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import u from "../../../../util/index.js";
import {getNoData} from "../../items/index.js";
import {subscribeWidget} from "../../../main-socket/index.js";
import {WIDGET} from "../../widgetConstants.js";

let fp;
let dates;
const widgetCalendar = () => {
    const $widgetCalendar = document.getElementsByClassName("widget-calendar-wrap");
    if ($widgetCalendar.length === 0) return;
    if ($('.flatpickr-calendar').length > 0) return;
    Mutil.lib.getFlatpickr().then(() => {
        fp = flatpickr($widgetCalendar, {
            inline: true,
            shorthandCurrentMonth: true,
            onChange: drawSelectSchedule,
        });
        fp.setDate(dayjs().toDate(), true);
        dates = dayjs().toDate();
    });

    setEvent();
}

function setEvent() {
    $('.js-move-today').off('click').on('click', () => {
        moveToday();
    })
    subscribeWidget({
        USER_ID: _USER_ID,
        TYPE: WIDGET.MY_SCHEDULE.SRNO
    })
}

function moveToday() {
    fp.setDate(dayjs().toDate(), true);
}

async function drawSelectSchedule(selectDates) {
    const newDates= selectDates?? dates;
    const selectDt = Time.format(newDates[0], 'type12')
    const calendarData = {
        "FIRST_DT": selectDt,
        "LAST_DT": selectDt,
        "PROJECT_SCHD_FILTER": "0,1",
        "TASK_SCHD_FILTER": "",
        "COLABO_SRNO": "",
    }
    const dat = await DashboardApi.getApi('getCalendarEvent', (calendarData));
    drawScheduleItems(dat, newDates);
    dates = newDates
}

const drawScheduleItems = ({SCHD_REC}, selectedDates) => {
    $('.widget-schedule-wrap .widget-schedule-list').empty();

    if (SCHD_REC && SCHD_REC.length === 0) {
        $('.widget-schedule-list').append(getNoData('schedule'))
        return;
    }

    const $calendarList = $('.widget-schedule-list');
    SCHD_REC.forEach((schd) => {
        const isHoliday = schd.GB === ScheduleCode.HOLIDAY;
        if (!ServerChecker.isEnter && !schd.COLABO_SRNO) return;

        const isGeneralProject = schd.GB === ScheduleCode.GENERAL;
        const isTask = schd.GB === ScheduleCode.TASK;
        const AttendInfo = ItemSchedule.getAttendInfo(schd.ATTENDENCE_REC);
        const isViewSchedule = AttendInfo.isAttend;
        const isExistSttgDttm = u.n2v(schd.STTG_DTTM, "") !== "";
        const isExistFnshDttm = u.n2v(schd.FNSH_DTTM, "") !== "";

        if (isTask && !isExistSttgDttm && !isExistFnshDttm) return;
        if (!(isGeneralProject && isViewSchedule) && !isTask) return;

        const isAllday = u.n2v(schd.ALL_DAY_YN, "N") === "Y";
        const sDay = Time.format(schd.STTG_DTTM, isGeneralProject && isAllday ? "type2" : "");
        const eDay = Time.format(schd.FNSH_DTTM, isGeneralProject && isAllday ? "type2" : "");

        const eventJson = {
            title: schd.TTL,
            allDay: isAllday,
            start: sDay,
            end: eDay,
        }
        if (isGeneralProject && isViewSchedule) { //G: General-Project

        } else if (isTask) {

            eventJson.allDay = schd.ALL_DAY_YN === "Y"; //task는 항상 ALLDAY이다.
            eventJson.title = "[" + i18next.t(TaskCode.OPTION._GB_NM[+schd.STTS]) + "]" + " " + schd.TTL;

            const startDateTime = Time.format(schd.STTG_DTTM, 'type2');
            const endDateTime = Time.format(schd.FNSH_DTTM, 'type2');
            eventJson.start = isExistSttgDttm ? startDateTime : endDateTime;
            eventJson.end = isExistFnshDttm ? endDateTime : startDateTime
        }

        const selectDate = Time.format(dayjs(selectedDates), 'type26');
        const localStart = Time.format(schd.STTG_DTTM, 'type26');
        const localEnd = Time.format(schd.FNSH_DTTM, 'type26');
        const startTime = Time.format(schd.STTG_DTTM, 'type20');
        const endTime = Time.format(schd.FNSH_DTTM, 'type20');
        const tag2html = Mutil.tag2html(eventJson.title);

        $calendarList.append(`
            <li class="js-all-post-item" colabo_srno=${schd.COLABO_SRNO} colabo_commt_srno=${schd.COLABO_COMMT_SRNO}>
                <span class="js-mouseover js-over-tooltip" mouseover-text="${tag2html}">${tag2html}</span>
                <span>${eventJson.allDay ?
            localStart + ", " +i18next .t(common.allDay) :
            selectDate + ", " + startTime + " ~ " + endTime}
                </span>
            </li>`)
    });
    $calendarList.removeClass('dash-pending')
    if ($calendarList.find('li.js-all-post-item').length === 0) {
        $calendarList.append(getNoData('schedule'))
    }
}

export {widgetCalendar, drawSelectSchedule, drawScheduleItems, moveToday}
